import * as CookieConsent from 'vanilla-cookieconsent';
import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { environment } from '@environment/environment';
import type { CookieConsentConfig } from 'vanilla-cookieconsent';
declare global {
    interface Window {
        dataLayer: any[];
    }
}

@Component({
    selector: 'app-cookie-consent',
    standalone: true,
    templateUrl: './cookie-consent.component.html',
    styleUrl: './cookie-consent.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class CookieConsentComponent implements AfterViewInit {
    public environment = environment;
    public config: CookieConsentConfig = {
        guiOptions: {
            consentModal: {
                layout: 'box inline',
                position: 'bottom left'
            },
            preferencesModal: {
                layout: 'box',
                position: 'right',
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        categories: {
            necessary: {
                readOnly: true
            },
            functionality: {},
            analytics: {
                services: {
                    ga4: {
                        label: '<a href="https://marketingplatform.google.com/about/analytics/terms/us/" target="_blank">Google Analytics 4</a>',
                        onAccept: () => {
                            console.log('ga4 accepted');
                            // Create a script element
                            const script = document.createElement('script');
                            // Set the source of the script to the GA4 URL
                            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-D4HMM43KPZ';
                            // Set async attribute
                            script.async = true;
                            // Append the script to the document's head
                            document.head.appendChild(script);

                            // Initialize GA4 after the script is loaded
                            script.onload = () => {
                                console.log('ga4 loaded');
                                window.dataLayer = window.dataLayer || [];
                                function gtag(p0?: string, p1?: Date | string) {
                                    window.dataLayer.push(arguments);
                                }
                                gtag('js', new Date());
                                gtag('config', 'G-D4HMM43KPZ');
                            };
                        },
                        onReject: () => {},
                        cookies: [
                            {
                                name: /^_ga/
                            }
                        ]
                    }
                }
            }
        },
        language: {
            default: 'en',
            autoDetect: 'browser',
            translations: {
                en: {
                    consentModal: {
                        title: 'Foxes eat cookies! 🦊🍪',
                        description:
                            'Our website uses cookies. Some are essential, while others help us improve the site and your experience.',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage preferences',
                        footer: `<a href="${environment.websiteUrl}/privacy">Privacy Policy</a>\n<a href="${environment.websiteUrl}/tos">Terms of use</a>`
                    },
                    preferencesModal: {
                        title: 'Privacy Settings',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Save preferences',
                        closeIconLabel: 'Close modal',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: 'Cookie Usage',
                                description:
                                    'Our website uses cookies. Some are essential, while others help us improve the site and your experience.'
                            },
                            {
                                title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
                                description:
                                    'We use essential cookies for site functionality, like navigation. Without these, the website won’t work properly.',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Analytics Cookies',
                                description:
                                    'We use analytics cookies to enhance your experience and analyze our website traffic. By using our site, you consent to the use of cookies for analytics through Google Analytics 4. Learn more about our cookie policy.',
                                linkedCategory: 'analytics'
                            }
                        ]
                    }
                }
            }
        }
    };

    public ngAfterViewInit(): void {
        CookieConsent.run(this.config);
    }

    public onOpenModal(): void {
        console.log('🚀 ~ CookieConsentComponent ~ onOpenModal ~ onOpenModal:');
        CookieConsent.showPreferences();
    }
}
